import Swiper, { Navigation, Pagination, EffectFade, Keyboard, A11y, Autoplay } from 'swiper';

function initProductImageCarousel() {
  var thumbsSwiper = new Swiper('.product-image-carousel .thumbs-carousel', {
    spaceBetween: 15,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  var mainSwiper = new Swiper('.product-image-carousel .main-carousel', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductImageCarousel();
});